class FlavorBundleBuilder {
  constructor(root) {
    this.root = root;
    this.slots = parseInt(root.dataset.slots, 10) || 10;
    this.formId = root.dataset.formId;
    this.price = root.dataset.price || '';
    this.options = Array.from(root.querySelectorAll('.fvb-opt'));
    this.checkboxes = Array.from(root.querySelectorAll('.fvb-opt__input'));
    this.countEl = root.querySelector('.fvb__count-current');
    this.fillEl = root.querySelector('.fvb__fill');
    this.errorEl = root.querySelector('.fvb__error');
    this.noResultsEl = root.querySelector('.fvb__no-results');
    this.hiddenInput = root.querySelector('input[name="properties[Saveurs choisies]"]');
    this.filterButtons = Array.from(root.querySelectorAll('.fvb__filter'));
    this.searchInput = root.querySelector('.fvb__search-input');
    this.activeFilter = 'all';
    this.searchQuery = '';

    this.sticky = document.getElementById(`fvb-sticky-${root.id.replace('fvb-', '')}`);
    this.stickyCount = this.sticky ? this.sticky.querySelector('.fvb-sticky__count') : null;
    this.stickyFill = this.sticky ? this.sticky.querySelector('.fvb-sticky__fill') : null;
    this.stickyCta = this.sticky ? this.sticky.querySelector('.fvb-sticky__cta') : null;

    this.checkboxes.forEach((checkbox) => checkbox.addEventListener('change', () => this.onChange()));
    this.filterButtons.forEach((button) => button.addEventListener('click', () => this.onFilter(button)));
    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => {
        this.searchQuery = this.searchInput.value.trim().toLowerCase();
        this.applyVisibility();
      });
    }
    if (this.stickyCta) {
      this.stickyCta.addEventListener('click', () => this.onStickyCta());
    }

    this.form = this.formId ? document.getElementById(this.formId) : null;
    if (this.form) {
      this.form.addEventListener('submit', (event) => this.onSubmit(event), true);
    }

    if (this.sticky && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        const visible = entries[0] && entries[0].isIntersecting;
        this.sticky.hidden = !visible;
      }, { threshold: 0 });
      this.observer.observe(this.root);
    }

    this.onChange();
  }

  get selected() {
    return this.checkboxes.filter((checkbox) => checkbox.checked);
  }

  onChange() {
    const selected = this.selected;
    const count = selected.length;
    const remaining = Math.max(this.slots - count, 0);

    this.countEl.textContent = count;
    this.fillEl.style.width = `${Math.min((count / this.slots) * 100, 100)}%`;
    this.hiddenInput.value = selected.map((checkbox) => checkbox.value).join(', ');

    this.checkboxes.forEach((checkbox) => {
      if (!checkbox.checked) checkbox.disabled = count >= this.slots;
    });

    if (count === this.slots) this.errorEl.hidden = true;

    if (this.stickyCount && this.stickyFill && this.stickyCta) {
      this.stickyFill.style.width = `${Math.min((count / this.slots) * 100, 100)}%`;
      if (count >= this.slots) {
        this.stickyCount.textContent = `${count} / ${this.slots} sélectionnées`;
        this.stickyCta.textContent = `Ajouter mon Pack — ${this.price}`;
        this.stickyCta.disabled = false;
      } else {
        this.stickyCount.textContent = `${count} / ${this.slots} sélectionnées · encore ${remaining}`;
        this.stickyCta.textContent = `Ajouter mon Pack — ${this.price}`;
        this.stickyCta.disabled = true;
      }
    }
  }

  onFilter(button) {
    this.activeFilter = button.dataset.filter;
    this.filterButtons.forEach((b) => b.classList.toggle('is-active', b === button));
    this.applyVisibility();
  }

  applyVisibility() {
    let visibleCount = 0;
    this.options.forEach((option) => {
      let matchesFilter = true;
      if (this.activeFilter === 'sans-sucre') {
        matchesFilter = option.dataset.group === 'sans-sucre';
      } else if (this.activeFilter !== 'all') {
        const tags = option.dataset.tags || '';
        matchesFilter = tags.includes(this.activeFilter.toLowerCase());
      }

      const matchesSearch = !this.searchQuery || (option.dataset.name || '').includes(this.searchQuery);
      const visible = matchesFilter && matchesSearch;
      option.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (this.noResultsEl) this.noResultsEl.hidden = visibleCount !== 0;
  }

  onStickyCta() {
    if (this.selected.length !== this.slots) return;
    if (this.form && typeof this.form.requestSubmit === 'function') {
      this.form.requestSubmit();
    } else if (this.form) {
      this.form.submit();
    }
  }

  onSubmit(event) {
    if (this.selected.length !== this.slots) {
      event.preventDefault();
      event.stopPropagation();
      this.errorEl.hidden = false;
      this.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}

document.querySelectorAll('.fvb').forEach((root) => new FlavorBundleBuilder(root));
